import { result } from "lodash";
import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../Common/tokenDecoder'
import { colorGenerator } from '../Common/Utils/colorGenarator';
export default {
    dashBoardData,
    getCollectionGroupByDay,
    getCollectionsGroupByMonth,
    GetCollectionCategoryTotalAmountMonthly,
    GetCollectionCategoryTotalAmountByDay,
    GetCollectionCategoryDataOfMonth,
    GetCollectionCategoryByYear,
    getOperationalEntityByGroupEntityID,
    getEstateCollectionsGroupByMonth,
    getEstateCollectionGroupByDay,
    GetEstateCollectionAmountByDivision,
    GetCheckRoleCollectionAmount,
    GetActualCollectionAmount,
    GetActivePluckers,
    GetCheackRollGtnGrnDetailsByOperationEntityID,
    getOperationEntitiesByGroupForDropDown
};

async function dashBoardData(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetDashBoardData', "operationEntityID=" + parseInt(operationEntityID));

    let formData = {
        dailyActiveUsers: response.data.dailyCustomerCount === null ? 0 : response.data.dailyCustomerCount,
        monthlyActiveUsers: response.data.monthlyCustomerCount === null ? 0 : response.data.monthlyCustomerCount,
        activeRoutes: response.data.activeRoutes === null ? 0 : response.data.activeRoutes,
        activeSessions: response.data.activeSessions === null ? 0 : response.data.activeSessions,
        dailyCollectionNetAmount: response.data.dailyTotalAmount === null ? 0 : response.data.dailyTotalAmount,
        monthlyCollectionNetAmount: response.data.monthlyTotalAmount === null ? 0 : response.data.monthlyTotalAmount,
        masterCardCustomerCountDaily: response.data.customerCountDailyMasterCard === null ? 0 : response.data.customerCountDailyMasterCard,
        masterCardCustomerCountMonthly: response.data.customerCountMonthlyMasterCard === null ? 0 : response.data.customerCountMonthlyMasterCard,
        masterCardTotalAmountDaily: response.data.totalAmountDailyMasterCard === null ? 0 : response.data.totalAmountDailyMasterCard,
        masterCardTotalAmountMonthly: response.data.totalAmountMonthlyMasterCard === null ? 0 : response.data.totalAmountMonthlyMasterCard,
    }

    return formData;
}

async function getCollectionGroupByDay(operationEntityID) {

    var amountArray = [];
    var actualAmountArray = [];
    var grossAmountArray = [];
    var daysArray = [];
    var days = [];
    var chartNetArray = [];
    var chartGrossArray = [];
    var chartActualArray = [];

    const response = await CommonGet('/api/Dashboard/GetCollectionGroupByDay', "operationEntityID=" + parseInt(operationEntityID));
    for (let item of Object.entries(response.data)) {
        amountArray.push(item[1]["totalAmount"]);
        days.push(item[1]["daysOfMonth"]);
        grossAmountArray.push(item[1]["grossAmount"]);
        actualAmountArray.push(item[1]["actualAmount"]);
    }

    let maxDay = Math.max(...days);




    for (let i = 1; i <= maxDay; i++) {

        const isValue = (element) => parseInt(element) == i;
        var indexVal = days.findIndex(isValue);


        if (indexVal != -1) {
            chartNetArray.push(amountArray[indexVal]);
            chartGrossArray.push(grossAmountArray[indexVal]);
            chartActualArray.push(actualAmountArray[indexVal]);

        } else {
            chartNetArray.push(0);
            chartGrossArray.push(0);
            chartActualArray.push(0);
        }


        daysArray.push(i);


    }

    const lineChartData = {
        labels: daysArray,
        datasets: [
            {
                label: "Net Amount",
                data: chartNetArray,
                borderColor: "#45c490"
            },
            {
                label: "Gross Amount",
                data: chartGrossArray,
                borderColor: "#008d93"
            },
            {
                label: "Actual Amount",
                data: chartActualArray,
                borderColor: "#2e5468"
            }
        ]
    }
    return lineChartData;
}

async function getEstateCollectionGroupByDay(operationEntityID) {

    var netAmountArray = [];
    var actualAmountArray = [];
    var grossAmountArray = [];
    var daysArray = [];

    const response = await CommonGet('/api/Dashboard/GetEstateCollectionGroupByDay', "operationEntityID=" + parseInt(operationEntityID));

    for (let item of Object.entries(response.data)) {
        netAmountArray.push(item[1]["netAmount"]);
        daysArray.push(item[1]["daysOfMonth"]);
        grossAmountArray.push(item[1]["grossAmount"]);
        actualAmountArray.push(item[1]["actualAmount"]);
    }

    const lineChartData = {
        labels: daysArray,
        datasets: [
            {
                label: "Net Amount",
                data: netAmountArray,
                borderColor: "#45c490"
            },
            {
                label: "Gross Amount",
                data: grossAmountArray,
                borderColor: "#008d93"
            },
            {
                label: "Actual Amount",
                data: actualAmountArray,
                borderColor: "#2e5468"
            }
        ]
    }
    return lineChartData;
}
async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionsGroupByMonth(operationEntityID) {

    const response = await CommonGet('/api/Dashboard/GetCollectionsGroupByMonth', "operationEntityID=" + parseInt(operationEntityID));

    var amountArray = [];
    var actualAmountArray = [];
    var grossAmountArray = [];
    var monthArray = [];

    for (let item of Object.entries(response.data)) {
        amountArray.push(item[1]["totalAmount"]);
        monthArray.push(item[1]["monthName"]);
        grossAmountArray.push(item[1]["grossAmount"]);
        actualAmountArray.push(item[1]["actualAmount"]);
    }

    const Data = {
        labels: monthArray,
        datasets: [
            {
                label: "Net Amount",
                data: amountArray,
                backgroundColor: "#45c490"
            },
            {
                label: "Gross Amount",
                data: grossAmountArray,
                backgroundColor: "#008d93"
            },
            {
                label: "Actual Amount",
                data: actualAmountArray,
                backgroundColor: "#2e5468"
            }
        ]
    }

    return Data;

}

async function getEstateCollectionsGroupByMonth(operationEntityID) {

    const response = await CommonGet('/api/Dashboard/GetEstateCollectionsGroupByMonth', "operationEntityID=" + parseInt(operationEntityID));

    var netAmountArray = [];
    var actualAmountArray = [];
    var grossAmountArray = [];
    var monthArray = [];

    for (let item of Object.entries(response.data)) {
        netAmountArray.push(item[1]["netAmount"]);
        monthArray.push(item[1]["monthName"]);
        grossAmountArray.push(item[1]["grossAmount"]);
        actualAmountArray.push(item[1]["actualAmount"]);
    }

    const barChartData = {
        labels: monthArray,
        datasets: [
            {
                label: "Net Amount",
                data: netAmountArray,
                backgroundColor: "#45c490"
            },
            {
                label: "Gross Amount",
                data: grossAmountArray,
                backgroundColor: "#008d93"
            },
            {
                label: "Actual Amount",
                data: actualAmountArray,
                backgroundColor: "#2e5468"
            }
        ]
    }

    return barChartData;

}

async function GetCollectionCategoryTotalAmountMonthly(operationEntityID) {
    let dynamicDataSet = [];
    let monthsArrray = [];

    const response = await CommonGet('/api/Dashboard/GetCollectionCategoryTotalAmountMonthly', "operationEntityID=" + parseInt(operationEntityID));
    response.data.forEach(x => monthsArrray.push(x.monthName));
    monthsArrray = [...new Set(monthsArrray)];

    let groupedResult = response.data.reduce(function (acc, obj) {
        let key = obj['collectionTypeMasterID']
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})

    let keys = Object.keys(groupedResult);

    keys.forEach(x => {

        //Check Again
        let valueArray = [, , , , , , , , , , ,]
        let res = {
            label: groupedResult[x][0]["collectionTypeName"],
            borderColor: colorGenerator(1),
            fill: false,
            pointRadius: 5,
            data: []
        }

        groupedResult[x].forEach(e => {
            monthsArrray.forEach((m, index) => {
                if (m === e.monthName) {
                    valueArray[index] = e.totalAmount
                }
            });
        });

        res.data = valueArray;
        dynamicDataSet.push(res);
    });

    const collectionCategoryLineChartMonthly = {
        labels: monthsArrray,
        datasets: dynamicDataSet
    };

    return collectionCategoryLineChartMonthly;

}


async function GetCollectionCategoryTotalAmountByDay(operationEntityID) {


    const response = await CommonGet('/api/Dashboard/GetCollectionCategoryTotalAmountByDay', "operationEntityID=" + parseInt(operationEntityID));

    let daysArray = [];

    response.data.forEach(e => {
        daysArray.push(e.daysOfMonth);
    });

    daysArray = [... new Set(daysArray)];

    let groupedResult = response.data.reduce(function (acc, obj) {
        let key = obj['collectionTypeMasterID']
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {});

    let keys = Object.keys(groupedResult);

    let dynamicDataSet = [];
    let dynamicDays = [];

    keys.forEach(x => {

        let daysCount = new Array(daysArray.length);

        let res = {
            label: groupedResult[x][0]["collectionTypeName"],
            borderColor: colorGenerator(1),
            fill: false,
            pointRadius: 5,
            data: []
        }

        groupedResult[x].forEach(e => {
            daysArray.forEach((a, index) => {
                if (a === e.daysOfMonth) {
                    daysCount[index] = e.totalAmount;
                }
            })
        });

        res.data = daysCount;
        dynamicDataSet.push(res);
    });


    const collectionCategoryLineChartData = {
        labels: daysArray,
        datasets: dynamicDataSet
    };

    return collectionCategoryLineChartData;

}


async function GetCollectionCategoryDataOfMonth(operationEntityID) {

    const response = await CommonGet('/api/Dashboard/GetCollectionCategoryDataOfMonth', "operationEntityID=" + parseInt(operationEntityID));
    var collectionCategoryLable = [];
    var collectionCategoryData = [];
    var chartDatasets = [];

    for (let item of Object.entries(response.data)) {
        collectionCategoryLable.push(item[1]["collectionTypeName"]);
        collectionCategoryData.push(item[1]["totalAmount"]);
    }

    const data = {
        dougnutChartData: {
            datasets: [{
                label: collectionCategoryLable,
                data: collectionCategoryData,
                backgroundColor: colorGenerator(collectionCategoryLable.length)
            }],
            labels: collectionCategoryLable,
        },
        collectionCategoryBarChartData: {
            labels: collectionCategoryLable,
            datasets: [{
                label: collectionCategoryLable,
                data: collectionCategoryData,
                backgroundColor: colorGenerator(collectionCategoryLable.length)
            }]
        }

    }

    return data;
}

async function GetCollectionCategoryByYear(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetCollectionCategoryTotalAmountByMonthlyThisYearPreviousYear', "operationEntityID=" + parseInt(operationEntityID));

    var collectionTypeArray = [];
    var thisYearMap = new Map();
    var previousYearMap = new Map();
    var thisYearData = [];
    var previousYearData = [];

    for (let item of Object.entries(response.data.previousYear)) {
        collectionTypeArray.push(item[1].collectionTypeName);
        previousYearMap.set(item[1].collectionTypeName, item[1].totalAmount);
    }

    for (let item of Object.entries(response.data.thisYear)) {
        collectionTypeArray.push(item[1].collectionTypeName);
        thisYearMap.set(item[1].collectionTypeName, item[1].totalAmount);
    }

    var sortedCollectionTypes = [... new Set(collectionTypeArray)];

    sortedCollectionTypes.forEach(ct => {
        thisYearData.push(thisYearMap.get(ct));
        previousYearData.push(previousYearMap.get(ct));
    });

    const data = {
        labels: sortedCollectionTypes,
        datasets: [
            {
                label: new Date().getFullYear() - 1,
                data: previousYearData,
                backgroundColor: "#45c490"
            },
            {
                label: new Date().getFullYear(),
                data: thisYearData,
                backgroundColor: "#008d93"
            }
        ]
    }

    return data;
}

async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function GetActivePluckers(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetEstateActivePlucker', "operationEntityID=" + parseInt(operationEntityID));

    let formData = {
        dailyActivePluckers: response.data.dailyActivePluckersCount === null ? 0 : response.data.dailyActivePluckersCount,
        monthlyActivePluckers: response.data.monthlyActivePluckersCount === null ? 0 : response.data.monthlyActivePluckersCount
    }

    return formData;
}


async function GetActualCollectionAmount(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetEstateActualCollection', "operationEntityID=" + parseInt(operationEntityID));

    let formData = {
        dailyActualCollectionNetAmount: response.data.dailyActualCollectionAmount === null ? 0 : response.data.dailyActualCollectionAmount,
        monthlyActualCollectionNetAmount: response.data.monthlyActualCollectionAmount === null ? 0 : response.data.monthlyActualCollectionAmount
    }

    return formData;
}

async function GetCheckRoleCollectionAmount(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetEstateCheckRoleCollection', "operationEntityID=" + parseInt(operationEntityID));

    let formData = {
        dailyCheckRoleCollectionAmount: response.data.dailyRoleCollectionAmount === null ? 0 : response.data.dailyRoleCollectionAmount,
        monthlyCheckRoleCollectionAmount: response.data.monthlyRoleCollectionAmount === null ? 0 : response.data.monthlyRoleCollectionAmount
    }
    return formData;
}


async function GetEstateCollectionAmountByDivision(operationEntityID) {

    const response = await CommonGet('/api/Dashboard/GetEstateDivisionCollection', "operationEntityID=" + parseInt(operationEntityID));

    var actualAmountArray = [];
    var netAmountArray = [];
    var monthArray = [];

    for (let item of Object.entries(response.data)) {
        netAmountArray.push(item[1]["netCollectionAmount"]);
        monthArray.push(item[1]["divisionName"]);
        actualAmountArray.push(item[1]["actualCollectionAmount"]);
    }

    const Data = {
        labels: monthArray,
        datasets: [
            {
                label: "Actual Amount",
                data: actualAmountArray,
                backgroundColor: "#2e5468"
            },
            {
                label: "Net Amount",
                data: netAmountArray,
                backgroundColor: "#45c490"
            }
        ]
    }

    return Data;
}

async function GetCheackRollGtnGrnDetailsByOperationEntityID(operationEntityID) {
    const response = await CommonGet('/api/Dashboard/GetCheackRollGtnGrnDetailsByOperationEntityID', "operationEntityID=" + parseInt(operationEntityID));

    var total = [];

    let totGrnNet = 0;
    let totGtnNet = 0;
    let totNetAmount = 0;
    response.data.forEach(x => {

        totGrnNet = totGrnNet + parseFloat(x.grnNet);
        totGtnNet = totGtnNet + parseFloat(x.gtnNet);
        totNetAmount = totNetAmount + parseFloat(x.netAmount);

        let model = {
            netAmount: parseFloat(x.netAmount),
            gtnNet: parseFloat(x.gtnNet),
            grnNet: parseFloat(x.grnNet),
            collectionPointName: x.collectionPointName,
            collectionPointID: x.collectionPointID
        }
        total.push(model);

    });
    let model = {
        netAmount: totNetAmount,
        gtnNet: totGtnNet,
        grnNet: totGrnNet,
        collectionPointName: "All",
        collectionPointID: 0
    }
    total.push(model);

    return total;
}